export enum moodleRightsTranslation {
  'true' = 'true',
  'false' = 'false'
}

export const moodleTranslation: { [k: string]: string } = {
  [moodleRightsTranslation.true]: 'присутствуют',
  [moodleRightsTranslation.false]: 'отсутствуют'
}
